import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-full-layout',
  templateUrl: './full-layout.component.html',
  styleUrls: ['./full-layout.component.scss']
})
export class FullLayoutComponent implements OnInit {

  constructor() { } 
  mainSidebarOpen: any;
  ngOnInit(): void {
  }
  hoverEffect($event, type) {
    this.mainSidebarOpen = $event;
    // this.mainSidebarOpen = $event.type == 'mouseover' ? 'sidenav-toggled-open' : '';
  }
  clickonBody() {
    // document.querySelector('.main-body').classList.remove('sidenav-toggled')
    // document.querySelector('.sidebar').classList.remove('sidebar-open')
  }
}
